// Fonction pour initialiser un slider spécifique
function initSlider(grid) {
  if (!grid) return;

  const items = grid.querySelectorAll('.image-grid-three-columns__grid__item');

  if (items.length === 0) return; // Si aucun élément n'est trouvé, quitter la fonction

  // Dupliquer les premiers et derniers éléments pour l'effet de boucle
  const cloneFirst = items[0].cloneNode(true);
  const cloneSecond = items[1].cloneNode(true);
  const cloneLast = items[items.length - 1].cloneNode(true);

  grid.appendChild(cloneFirst); // Ajouter le premier élément à la fin
  grid.appendChild(cloneSecond); // Ajouter le deuxième élément à la fin
  grid.insertBefore(cloneLast, items[0]); // Ajouter le dernier élément au début

  // Mise à jour de la liste des éléments
  const allItems = grid.querySelectorAll('.image-grid-three-columns__grid__item');

  // Initialisation
  let currentIndex = 1; // On commence par la vraie première image
  const totalItems = allItems.length; // Inclut les éléments clonés

  // Fonction pour mettre à jour la position initiale
  function updateInitialPosition() {
    // Calcule le décalage pour centrer la deuxième image
    const offset = -currentIndex * 50 + 25; // Décalage pour centrer l'image
    grid.style.transition = 'none'; // Désactiver la transition initiale
    grid.style.transform = `translateX(${offset}%)`;
  }

  // Fonction pour passer à l'image suivante
  function slideToNext() {
    // Incrémente l'index
    currentIndex++;

    // Transition vers la prochaine image
    const offset = -currentIndex * 50 + 25;
    grid.style.transition = 'transform 0.5s ease-in-out';
    grid.style.transform = `translateX(${offset}%)`;

    // Vérifie si on est à la fin pour revenir au début
    if (currentIndex >= totalItems - 2) {
      // Transition sans animation pour éviter le saut
      setTimeout(() => {
        grid.style.transition = 'none'; // Désactiver la transition
        currentIndex = 1; // Revenir à la première vraie image
        const resetOffset = -currentIndex * 50 + 25;
        grid.style.transform = `translateX(${resetOffset}%)`;
      }, 500); // Durée de la transition en millisecondes
      // Vérifie la largeur de l'écran et initialise le slider uniquement sur mobile
    }
  }

  // Position initiale pour centrer la deuxième image
  updateInitialPosition();

  // Démarre l'auto-scroll toutes les 3 secondes (3000 ms)
  const scrollInterval = setInterval(slideToNext, 3000);

  // Fonction pour nettoyer l'intervalle
  function stopAutoScroll() {
    clearInterval(scrollInterval);
  }

  // Exemple d'utilisation du nettoyage
  // Tu peux appeler `stopAutoScroll()` lorsque tu veux arrêter le défilement automatique
  // Par exemple, lorsque l'utilisateur quitte la page ou le composant
}
